export const TEST_ID = 'noAircraftCard';
